import CommonLayout from "../../../layouts/CommonLayout";
import useAuthStore from "../../../../store/authStore";

const AccountInfoPage = () => {
    const { member } = useAuthStore();

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('ko-KR');
    };

    return (
        <CommonLayout title="계정 정보">
            <div className="space-y-1">
                <div className="p-4 flex justify-between">
                    <span className="text-md">전화번호</span>
                    <span className="text-md text-gray-600">{member?.phone}</span>
                </div>
                <div className="p-4 flex justify-between">
                    <span className="text-md">가입일</span>
                    <span className="text-md text-gray-600">{member?.createdAt && formatDate(member.createdAt)}</span>
                </div>
                <div className="p-4 flex justify-between">
                    <span className="text-md">가입 형태</span>
                    <span className="text-md text-gray-600">{member?.provider === 'KAKAO' ? '카카오' : '전화번호 가입'}</span>
                </div>
            </div>
        </CommonLayout>
    );
};

export default AccountInfoPage;
